var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.3,
    height: 16.3,
    viewBox: "0 0 14.3 16.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-2_1_",
    "data-name": "share-2 (1)",
    transform: "translate(-2.35 -1.35)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2027",
    "data-name": "Ellipse 2027",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(12 2)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2028",
    "data-name": "Ellipse 2028",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(3 7.5)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2029",
    "data-name": "Ellipse 2029",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(12 13)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3255",
    "data-name": "Line 3255",
    x2: 5.182,
    y2: 3.02,
    transform: "translate(7.241 10.733)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3256",
    "data-name": "Line 3256",
    x1: 5.175,
    y2: 3.02,
    transform: "translate(7.241 5.422)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9da802964174c125be576eff28b795bd.svg";
export { ForwardRef as ReactComponent };